// extracted by mini-css-extract-plugin
export var btnStartNow = "styles-module--btn-start-now--bb44d";
export var header = "styles-module--header--a1b8e";
export var mobileNav = "styles-module--mobile-nav--fdae9";
export var navMidHeader = "styles-module--nav-mid-header--5738f";
export var socialIcons = "styles-module--social-icons--610cf";